import { Box, Button, styled } from '@mui/material';
import { Grid } from '@mui/system';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  padding: '1rem',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
  height: '100%',
  boxSizing: 'border-box',
}));

const Container = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  fontSize: '0.875rem',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

const DateRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

const SpacedContainer = styled(Grid)({ padding: '0.5rem' });

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

const StatusRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  flex: 1,
});

const FooterBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '1.5rem',
  flexShrink: 0,
  justifyContent: 'space-between',
});

const RoleBox = styled(Box)({
  display: 'flex',
  width: '50%',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

const AvatarRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  marginTop: '0.25rem',
});

const OverlayContainer = styled(Box)({
  position: 'relative',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const BlurOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  backdropFilter: 'blur(4px)',
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  zIndex: 10,
}));

const CreateModelSupportButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(1),
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const BlurredContent = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasModelSupport' && prop !== 'readOnly',
})<{ hasModelSupport?: boolean; readOnly?: boolean }>(({ hasModelSupport, readOnly }) => ({
  filter: hasModelSupport === false && !readOnly ? 'blur(2px)' : 'none',
  pointerEvents: hasModelSupport === false && !readOnly ? 'none' : 'auto',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

const DeleteModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 480,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.background.paper,
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[24],
  padding: theme.spacing(3),
  outline: 'none',
}));

const DeleteModalActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

const DeleteModalCloseButtonContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

export {
  StyledBox,
  AvatarRow,
  Container,
  DateRow,
  FooterBox,
  RoleBox,
  SpacedContainer,
  StatusRow,
  Wrapper,
  OverlayContainer,
  BlurOverlay,
  CreateModelSupportButton,
  BlurredContent,
  DeleteModalContainer,
  DeleteModalActions,
  DeleteModalCloseButtonContainer,
};
